import { Tag, Tooltip, Icon, iconWeight } from '@nula/core-ui';
import type { Access } from '@/lib/sharing/utils/permissions';
import { PERMISSION_LABEL } from '@/lib/sharing/utils/permissions';

interface SharedBadgeProps {
  access: Access | null | undefined;
}

export function SharedBadge({ access }: SharedBadgeProps) {
  if (!access || access.permission === 'owner') return null;

  const label = PERMISSION_LABEL[access.permission] ?? 'Shared';
  const granter = access.grantedBy?.name;
  const tooltip = granter ? `${label} · Shared by ${granter}` : `${label} · Shared with you`;

  return (
    <Tooltip title={tooltip}>
      <Tag
        color="default"
        bordered={false}
        closable={false}
        icon={<Icon name="group" size={12} weight={iconWeight.light} />}
      >
        Shared
      </Tag>
    </Tooltip>
  );
}
